<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">
                {{ $t("CASH_REGISTER_READINGS.EDIT_CASH_REGISTER_READING") }}
              </h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <cash-register-reading-form
              :loading="loading"
              :cashRegisterReadingData="cashRegisterReading"
              :formErrors="formErrors"
              @cashRegisterReadingSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import CashRegisterReadingForm from "./partials/CashRegisterReadingForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultCashRegisterReading from "./defaultCashRegisterReading";

export default {
  layout: "DashboardLayout",

  components: { CashRegisterReadingForm },

  mixins: [alertLeave],

  data() {
    return {
      cashRegisterReading: cloneDeep(defaultCashRegisterReading),
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("cashRegisterReadings/get", id);
        this.cashRegisterReading =
          this.$store.getters["cashRegisterReadings/cashRegisterReading"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    goBack() {
      this.$router.push({ name: "List CashRegisterReadings" });
    },

    viewCashRegisterReading() {
      this.alertLeave = false;
      this.$router.push({
        name: "View CashRegisterReading",
        params: { id: this.cashRegisterReading.id },
      });
    },

    async handleSubmit(cashRegisterReading) {
      this.loading = true;
      const cashRegisterReadingData = cloneDeep(cashRegisterReading);

      try {
        await this.$store.dispatch(
          "cashRegisterReadings/update",
          cashRegisterReadingData
        );
        this.$notify({
          type: "success",
          message: this.$t("CASH_REGISTER_READINGS.CASH_REGISTER_READING_UPDATED"),
        });
        this.viewCashRegisterReading();
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
